import styles from '../StickyFilter.module.scss';

export const showVisibleFilter = (scrollViewList: HTMLDivElement) => {
    const scrollViewElements = scrollViewList?.querySelectorAll('section');
    if (scrollViewElements) {
        const scrollViewHeight = scrollViewList.getBoundingClientRect().height;
        let controlHeight = 0;

        scrollViewElements.forEach((element) => {
            const elementHeight = element.getBoundingClientRect().height;

            controlHeight += elementHeight;

            element.classList.toggle(
                styles.Hidden,
                controlHeight > scrollViewHeight
            );
        });
    }
};

export const showScrollView = (
    scrollViewList: HTMLDivElement,
    show: boolean
) => {
    if (show) {
        scrollViewList.classList.remove(styles.Hidden);
    } else {
        scrollViewList.classList.add(styles.Hidden);
    }
};
